// Troy Transportes — Shared constants
export const WHATSAPP_NUMBER = "31991846450";
// Número dedicado para receber cadastros de motoristas
export const DRIVER_CONTACT_WHATSAPP = "31983627648";
export const WHATSAPP_LINK = `https://wa.me/55${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Olá Troy Transportes! Gostaria de solicitar uma corrida."
)}`;
export const WHATSAPP_PASSENGERS_GROUP =
  "https://chat.whatsapp.com/LJZz3RMmnQL4En5RnY6hyp?s=cl&p=i&mlu=0&ilr=4";
// Backward-compatible alias (group is shared — passengers request, drivers answer)
export const WHATSAPP_DRIVERS_GROUP = WHATSAPP_PASSENGERS_GROUP;
export const COMPANY_NAME = "Troy Transportes";
export const COMPANY_TYPE = "Grupo de Transporte";
export const SLOGAN = "Chegou, chamou, Troy levou!";
export const REGION = "General Carneiro e regiões próximas";
export const REGION_SHORT = "General Carneiro - MG";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_06002a45-82af-47aa-a34e-c89768ffdf80/artifacts/b9en6oc2_CB191ADC-F4FA-4191-A2C2-474C277A8A81.png";
export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/06002a45-82af-47aa-a34e-c89768ffdf80/images/7adbf62d867952cd5fde41c6e7ee5e706b2edad7044e2ed411a274ee6191981b.png";
export const SERVICES_BG =
  "https://static.prod-images.emergentagent.com/jobs/06002a45-82af-47aa-a34e-c89768ffdf80/images/d4b0c564adfd21d9fc3d38e30238a8c1d24cb3b794ebe00fea57d1b8376f4737.png";
export const DRIVER_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_urban-rides-26/artifacts/dqsy0hsk_WhatsApp%20Image%202026-09-21%20at%2016.04.59.jpeg";
export const PASSENGER_IMAGE =
  "https://images.unsplash.com/photo-1758315427147-39bd97b36316?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBzbWFydHBob25lJTIwY2FyJTIwYmFjayUyMHNlYXR8ZW58MHx8fHwxNzc3NTQ1MjAyfDA&ixlib=rb-4.1.0&q=85";
export const CITY_BLUR =
  "https://static.prod-images.emergentagent.com/jobs/06002a45-82af-47aa-a34e-c89768ffdf80/images/be09e04b059c0e4353fd39557ce4ad0a5a4e4f05e2c11bf0a39b0f692ccb81f1.jpeg";

export const whatsappTextLink = (msg) =>
  `https://wa.me/55${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
